import { render, staticRenderFns } from "./FileSubmissionPage.vue?vue&type=template&id=8dafc480&scoped=true"
import script from "./FileSubmissionPage.vue?vue&type=script&lang=ts"
export * from "./FileSubmissionPage.vue?vue&type=script&lang=ts"
import style0 from "./FileSubmissionPage.vue?vue&type=style&index=0&id=8dafc480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dafc480",
  null
  
)

export default component.exports